import React from "react";
import PropTypes from "prop-types";

import { Modal, Header, Close } from "MODULES/shared/components/Modal";
import Form from "./Form";

export default function Create({ open, close }) {
  return (
    <div>
      <Modal open={open} close={close} dialogClass="modal-md">
        <Header>
          <Close close={close} />
          <h4 className="modal-title">Add Physical Address</h4>
        </Header>
        <Form close={close} initialValues={{ primary: false }} />
      </Modal>
    </div>
  );
}

Create.propTypes = {
  open: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./app/modules/companies/components/Detail/PhysicalAddresses/Create/CreatePhysicalAddress.jsx